export default "__VITE_ASSET__CxzvKJ_3__"